export default "__VITE_ASSET__c4e7a971__"